module.exports = __webpack_public_path__ + "static/media/phillipworks-bg.be90ab68.png";